export const EXPERIMENTS = {
  ENABLE_MULTILINE_ADDRESS: 'specs.forms.MultilineAddressInTemplates',
  SHOW_DEMO_FORM: 'specs.forms.ShowDemoForm',
  ENABLE_PRESET_TAB: 'specs.forms.EnablePresetTab',
  TEMPLATE_DESIGNER: 'specs.forms.TemplateDesigner',
  REMOVE_BOOKINGS_DEPENDENCY: 'specs.services.RemoveBookingsDependency',
  BIF_SILENT_INSTALL: 'bifOnMeetingsSilentInstall',
  STUDIO2_THUMBNAILS: 'formsStudio2Thumbnails',
  NEW_MANAGE_TAB_SETTINGS: 'newManageTabSettings',
};
